import { VxeSplitPane } from 'vxe-pc-ui';
export default {
  name: 'XSplitPane',
  components: {
    VxeSplitPane
  },
  props: {},
  setup(props, context) {}
};